import { IEndpointData } from 'SharedDir/declarations/shared';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';

const feedbackUrl = `${SERVER_API}/feedback/help-business`;

export const FEEDBACK = {
  LIST: {
    method: 'GET',
    url: `${feedbackUrl}`,
  } as IEndpointData,
  STORE: {
    method: 'POST',
    url: `${feedbackUrl}`,
  } as IEndpointData,
};
